export const NOTIFICATION_TYPES = {
  PATIENT_SETUP_COMPLETED: 'patient-setup-completed',
  RUSH_CASE: 'rush-case',
  UPDATED_NOTIFICATION: 'updated-notification',
  LOW_BRACKET_INVENTORY: 'low-bracket-inventory',
  NEW_CASE_NOTE: 'new-case-note',
  NEW_CASE_NOTE_FOR_MANAGEMENT: 'new-case-note-for-management',
  TRAY_DESIGN_REQUEST_COMPLETED: 'tray-design-request-completed'
};

export const NOTIFICATION_ALERTS = [
  NOTIFICATION_TYPES.RUSH_CASE,
  NOTIFICATION_TYPES.LOW_BRACKET_INVENTORY,
  NOTIFICATION_TYPES.NEW_CASE_NOTE_FOR_MANAGEMENT,
  NOTIFICATION_TYPES.TRAY_DESIGN_REQUEST_COMPLETED
];
